export default __webpack_public_path__ + "static/media/java_nptel.633f8427.png";